/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentResultFragmentDoc } from '../../shippers/components/ShipperFacilities/ListTrailerPoolsModal/ShipmentAutosuggest/graphql/ShipmentResultFragment'
import { EquipAttributeFragmentDoc } from './EquipAttributeFragment'
import { StopInformationFragmentDoc } from './StopInformationFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipmentInformationQueryVariables = Types.Exact<{
  shipmentId: Types.Scalars['ID']
}>

export type IShipmentInformationQuery = { __typename?: 'Query' } & {
  shipment?: Types.Maybe<
    { __typename?: 'Shipment' } & Pick<
      Types.IShipment,
      | 'id'
      | 'totalWeight'
      | 'totalPalletCount'
      | 'shipperPerMileFuelRate'
      | 'shipperMiles'
      | 'shipperRate'
      | 'shipperRateType'
      | 'carrierSpecialInstructions'
      | 'team'
      | 'loadingType'
    > & {
        shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
          Types.IShipperApplication,
          'id' | 'name'
        >
        equipment: { __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id' | 'key' | 'parentKey'>
        equipmentAttributes: Array<
          { __typename?: 'ShipmentEquipmentAttribute' } & Pick<
            Types.IShipmentEquipmentAttribute,
            'id' | 'attributeValue'
          > & {
              parent: { __typename?: 'EquipmentAttribute' } & Pick<
                Types.IEquipmentAttribute,
                'id' | 'key'
              >
            }
        >
        carrierManager?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
        characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
          Types.IShipmentCharacteristics,
          'hot'
        >
        stops: Array<
          { __typename?: 'ShipmentStop' } & Pick<
            Types.IShipmentStop,
            | 'id'
            | 'stopType'
            | 'stopSequence'
            | 'dropTrailer'
            | 'specialInstruction'
            | 'weight'
            | 'palletCount'
            | 'commodity'
            | 'billOfLadingReference'
            | 'poReference'
          > & {
              mergedFacility: { __typename?: 'MergedFacility' } & {
                shipperFacility?: Types.Maybe<
                  { __typename?: 'ShipperFacility' } & Pick<Types.IShipperFacility, 'id' | 'uuid'>
                >
                facility: { __typename?: 'Facility' } & Pick<Types.IFacility, 'id' | 'name'> & {
                    location: { __typename?: 'Location' } & Pick<
                      Types.ILocation,
                      'id' | 'address' | 'city' | 'stateCode'
                    >
                  }
              }
              appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                Types.IShipmentStopAppointment,
                'id' | 'appointmentType' | 'startAt' | 'startAtHasTime' | 'endAt' | 'endAtHasTime'
              >
              genericCommodity?: Types.Maybe<
                { __typename?: 'Commodity' } & Pick<Types.ICommodity, 'id'>
              >
            }
        >
        firstPickup: { __typename?: 'ShipmentStop' } & Pick<
          Types.IShipmentStop,
          'id' | 'city' | 'stateCode'
        >
        lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
          Types.IShipmentStop,
          'id' | 'city' | 'stateCode'
        >
      }
  >
}

export const ShipmentInformationDocument = gql`
  query ShipmentInformation($shipmentId: ID!) {
    shipment(id: $shipmentId) {
      ...ShipmentResult
      id
      shipperApplication {
        id
        name
      }
      equipment {
        id
        key
        parentKey
      }
      equipmentAttributes {
        ...EquipAttribute
      }
      carrierManager {
        id
        fullName
      }
      totalWeight
      totalPalletCount
      shipperPerMileFuelRate
      shipperMiles
      shipperRate
      shipperRateType
      carrierSpecialInstructions
      team
      loadingType
      characteristics {
        hot
      }
      stops {
        ...StopInformation
      }
    }
  }
  ${ShipmentResultFragmentDoc}
  ${EquipAttributeFragmentDoc}
  ${StopInformationFragmentDoc}
`

/**
 * __useShipmentInformationQuery__
 *
 * To run a query within a React component, call `useShipmentInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentInformationQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useShipmentInformationQuery(
  baseOptions: Apollo.QueryHookOptions<
    IShipmentInformationQuery,
    IShipmentInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShipmentInformationQuery, IShipmentInformationQueryVariables>(
    ShipmentInformationDocument,
    options
  )
}
export function useShipmentInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IShipmentInformationQuery,
    IShipmentInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShipmentInformationQuery, IShipmentInformationQueryVariables>(
    ShipmentInformationDocument,
    options
  )
}
export type ShipmentInformationQueryHookResult = ReturnType<typeof useShipmentInformationQuery>
export type ShipmentInformationLazyQueryHookResult = ReturnType<
  typeof useShipmentInformationLazyQuery
>
export type ShipmentInformationQueryResult = Apollo.QueryResult<
  IShipmentInformationQuery,
  IShipmentInformationQueryVariables
>
